/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
// import config from '../../config/createPayment.config.json';
import axios from 'axios';
import { apiConfig } from '@/config/apiConfig';

export interface PaymentUserProps {
  email: string;
  firstName: string;
  lastName: string;
  password?: string;
  phoneNumber?: string;
  jwtToken?: string;
  headers: any;
}

export interface IPaymentUserMethods extends IPluginMethodMap {
  createPayment(args: any): Promise<any>;
}

export class PaymentUserService implements IAgentPlugin {
  readonly methods: IPaymentUserMethods;

  constructor() {
    this.methods = {
      createPayment: this.createPayment.bind(this),
    };
  }

  async createPayment(args: PaymentUserProps) {
    console.log(`createPayment service:`, args);
    try {
    } catch (err: any) {
      console.log(`Payment user error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
